import { createStructuredSelector, createSelector } from 'reselect';
import getSolution from '../solutions';

export const bffDomain = () => state => state.Data;

const globalLoaderDomain = () => state => state.root.globalLoader;

export const translationsSelector = state => state.Data.translations;

const selectSolutionsData = createSelector(
  bffDomain(),
  subState => getSolution(subState.locale, subState.isIraDocumentGenerationEnabled)
);

const selectShowLoader = createSelector(
  globalLoaderDomain(),
  substate => substate.show
);

export const selectLocale = createSelector(
  bffDomain(),
  ({ locale }) => locale || 'en_US'
);

const selectLocaleCountry = createSelector(
  selectLocale,
  locale => (locale && locale.split('_')[1]) || 'US'
);

const selectHeader = createSelector(
  bffDomain(),
  data => data?.header ?? {}
);

export const selectIsCNEnv = createSelector(
  bffDomain(),
  ({ isCNEnv }) => !!isCNEnv
);

export const selectIsApp = createSelector(
  bffDomain(),
  ({ isApp }) => !!isApp
);

export default createStructuredSelector({
  translations: translationsSelector,
  solutionsData: selectSolutionsData,
  showLoader: selectShowLoader,
  localeCountry: selectLocaleCountry,
  locale: selectLocale,
  header: selectHeader,
  isCNEnv: selectIsCNEnv,
  isApp: selectIsApp,
});
